<!--
  转账
  lovi 2020-07-11
-->
<template>
  <div class="w100">
    <van-nav-bar class="gradient" :fixed="true" left-arrow @click-left="_back">
      <template slot="title">
        <span
          :class="{ active: flag == index }"
          v-for="(item, index) in title"
          :key="index"
          @click="changeType(index)"
        >
          {{ item }}
        </span>
      </template>
      <span slot="right" @click="_linkFun('/record?flag=3')">
        {{ $t("common.transferRecord") }}
      </span>
    </van-nav-bar>

    <single v-if="flag == 0" />
    <batch v-if="flag == 1" />
  </div>
</template>

<script>
import Single from "./single";
import Batch from "./batch";
export default {
  name: "transfer",
  components: {
    Single,
    Batch
  },
  data() {
    return {
      title: [
        this.$t("transfer.singleTransfer"),
        this.$t("transfer.batchTransfer")
      ],
      flag: 0, //转账类型，0单笔转账，1批量转账
      transferPhone: "",
      btnLoading: false,
      amountFlag: false,
      amountData: {}
    };
  },
  created() {
    this.flag = this.$route.query.flag || 0;
  },
  mounted() {},
  computed: {},
  methods: {
    changeType(flag) {
      //修改类别
      let vm = this;
      vm.flag = flag;
      vm.$router.replace({
        path: "/transfer",
        name: "transfer",
        query: { flag: flag }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-nav-bar__title {
  span {
    margin-left: 12px;
    color: rgba(255, 255, 255, 0.5);
    &:first-child {
      margin-left: 0;
    }
    &.active {
      color: #fff;
    }
  }
}
</style>
